document.addEventListener('DOMContentLoaded', () => {

  const sections = document.querySelectorAll('.store-locator');

  sections.forEach((section) => {

    const tabs = section.querySelectorAll('.store-locator__tab');
    const panels = section.querySelectorAll('.store-locator__panel');

    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {

      tab.addEventListener('click', () => {

        const target = tab.dataset.store;

        tabs.forEach((button) => {
          button.classList.remove('is-active');
          button.setAttribute('aria-selected', 'false');
        });

        panels.forEach((panel) => {
          panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        const activePanel = section.querySelector(
          `.store-locator__panel[data-store="${target}"]`
        );

        if (activePanel) {
          activePanel.classList.add('is-active');

          activePanel.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }

      });

    });

  });

});